export default __webpack_public_path__ + "static/media/icn_categories.89cc0ec2.svg";